/* eslint-disable no-confusing-arrow */
import _ from 'lodash';

export const fileLink = data => {
	if (data.selected === 'file') {
		// TODO: replace in future with cdn provided from Gil
		return _.get(data, 'file.url', '').replace(
			'https://firebasestorage.googleapis.com/v0/b/makochart2021.appspot.com/o/',
			'https://glglzv1cdn.rabbicdn.com/'
		);
	}

	return _.get(data, 'remoteURL', '');
};
